import { generated } from '@varos/research-sdk-api';
import { ButtonProps } from '@chakra-ui/react';

export const COLOR_MAPPING: Record<
    generated.ColorPalette,
    Exclude<ButtonProps['colorScheme'], undefined>
> = {
    blue: 'blue',
    cyan: 'cyan',
    green: 'green',
    yellow: 'yellow',
    orange: 'orange',
    red: 'red',
    magenta: 'pink',
    indigo: 'purple',
    gray: 'gray',
};
